import { useEffect } from 'react';
import * as _ from 'lodash';
import { environment } from '../../../../environments/environment';
import { makeVar, useReactiveVar } from '@apollo/client';

const videoCategories = makeVar<VideoCategoryWithVideos[]>([]);

export function useVideoCategories() {
  const categories = useReactiveVar(videoCategories);

  useEffect(() => {
    let breakFlag = false;

    if (!categories.length) {
      fetchVideoCategories().then((data) => {
        if (!breakFlag) {
          videoCategories(data);
        }
      });
    }

    return () => {
      breakFlag = true;
    };
  }, [categories]);

  return categories;
}

const fetchVideoCategories = async (): Promise<VideoCategoryWithVideos[]> => {
  try {
    const result = await fetch(
      environment.strapiUrl +
        `/api/video-categories?sort[0]=sortingOrder:asc&filters[type][$eq]=BASICS&populate[videos][populate][0]=picture&pagination[pageSize]=100&publicationState=live`,
      {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + environment.strapiToken,
        },
      }
    ).then((res) => res.json());

    if (result) {
      return _.sortBy(result.data, 'sortingOrder').map((item: any) => ({
        id: item.id,
        ...item.attributes,
        videos: _.sortBy(item.attributes.videos.data, 'sortingOrder').map(
          (v: any) => ({
            id: v.id,
            ...v.attributes,
            picture: {
              url: v.attributes.picture.data.attributes.url,
              formats: {
                large: v.attributes.picture.data.attributes.formats.large?.url,
                small: v.attributes.picture.data.attributes.formats.small?.url,
                medium: v.attributes.picture.data.attributes.formats.medium?.url,
                thumbnail:
                  v.attributes.picture.data.attributes.formats.thumbnail?.url,
              },
            },
          })
        ),
      }));
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

export interface Video {
  description: string;
  duration: string;
  id: number;
  picture: {
    url: string;
    formats: {
      large: string;
      small: string;
      medium: string;
      thumbnail: string;
    };
  };
  sortingOrder?: number;
  title: string;
  url: string;
}

export interface VideoCategoryWithVideos {
  id: number;
  sortingOrder?: number;
  subTitle?: string;
  title: string;
  type: VideoContentCategoryType;
  videos: Video[];
}

export enum VideoContentCategoryType {
  Basics = 'BASICS',
  LiveWebinars = 'LIVE_WEBINARS',
  MedicareFastFacts = 'MEDICARE_FAST_FACTS',
  Podcast = 'PODCAST',
}
